import { ExpandMore } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
} from '@mui/material';
import { Fragment, memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import PmiTextField from 'shell/components/shared/text-field';
import { AccordionPersonForm } from 'shell/view-models/accordion-person-form';

interface AccordionPersonComponentProps {
  form: AccordionPersonForm | null;
}

const AccordionPersonComponent = ({ form }: AccordionPersonComponentProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-person-content"
          id="panel-person-header"
          expandIcon={<ExpandMore />}
        >
          <Typography>Persona</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <PmiTextField
                label="Codice fiscale"
                aria-label="Codice fiscale"
                fullWidth
                value={form?.fiscalCode?.toUpperCase()}
                inputProps={{ maxLength: '16' }}
                disabled
              />
            </Grid>
            <Grid item container spacing={2} xs={12} md={10} alignItems="center">
              <Grid item xs={12} md={9}>
                <PmiTextField
                  label="Cognome"
                  aria-label="Cognome"
                  fullWidth
                  disabled
                  value={form?.surname}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControlLabel
                  control={
                    <Checkbox
                      id="withoutSurname"
                      inputProps={{ 'aria-label': 'Persona senza cognome' }}
                      disabled
                    />
                  }
                  value={form?.withoutSurname}
                  label="Persona senza cognome"
                />
              </Grid>
            </Grid>
            <Grid item container spacing={2} xs={12} md={10} alignItems="center">
              <Grid item xs={12} md={9}>
                <PmiTextField
                  label="Nome"
                  aria-label="Nome"
                  fullWidth
                  disabled
                  value={form?.name}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControlLabel
                  control={
                    <Checkbox
                      id="withoutName"
                      disabled
                      inputProps={{ 'aria-label': 'Persona senza nome' }}
                    />
                  }
                  value={form?.withoutName}
                  label="Persona senza nome"
                />
              </Grid>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

AccordionPersonComponent.displayName = 'Accordion person component';

const AccordionPerson = memo(AccordionPersonComponent);

export default AccordionPerson;
